<template>
  <v-container class="login-container" fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="5" lg="4">
        <v-card class="login-card pa-8" flat>
          <div class="text-center mb-6">
            <v-img
              :src="require('@/assets/NEW_Energie_Logo_RBG_2023.svg')"
              max-height="48"
              contain
              class="mb-6"
            />
            <h2 class="login-title">Energyview</h2>
            <p class="login-subtitle">Melden Sie sich an, um fortzufahren.</p>
          </div>
          <v-btn
            @click="signIn"
            color="primary"
            block
            large
            class="login-btn"
          >
            Jetzt Anmelden
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import router from "../router"
import store from "../store"
import { defineComponent, onMounted } from "vue"

export default defineComponent({
    setup() {
        onMounted(() => {
            if (store.state.auth.isSignedIn) {
                router.push("/")
            }
        })

        // Nicht notwendig, wenn die Anmeldung erzwungen wird
        const signIn = () => {
            loginNew.auth()
            console.log("auth")
        }

        return {
            signIn
        }
    }
})
</script>

<style scoped>
.login-container {
  min-height: 70vh;
}

.login-card {
  background: #ffffff !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(34, 38, 47, 0.12) !important;
}

.login-title {
  font-family: 'Geometria', Arial, sans-serif !important;
  font-weight: 700 !important;
  font-size: 26px !important;
  color: #22262f !important;
  line-height: 1.3 !important;
  margin-bottom: 8px;
}

.login-subtitle {
  font-family: 'Geometria', Arial, sans-serif;
  font-size: 15px;
  color: #22262f;
  opacity: 0.6;
  margin: 0;
}

.login-btn {
  margin-top: 10px;
  height: 48px !important;
  font-size: 16px !important;
}
</style>